import React from 'react';
import {
  DialogContent,
  DialogTitle,
} from '@mui/material';
import AppDialog from '../common/AppDialog';
import CategoryForm from './CategoryForm';
import { Category, CreateCategoryRequest, UpdateCategoryRequest } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';

interface CategoryDialogProps {
  open: boolean;
  onClose: () => void;
  category?: Category | null;
  onSubmit: (data: CreateCategoryRequest | UpdateCategoryRequest) => Promise<void>;
  isLoading?: boolean;
}

const CategoryDialog: React.FC<CategoryDialogProps> = ({
  open,
  onClose,
  category,
  onSubmit,
  isLoading = false,
}) => {
  const { t } = useLanguage();
  return (
    <AppDialog presentation="compact" closeDisabled={isLoading}
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: { minHeight: 400 }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>{category ? t('category.edit') : t('category.create')}</span>
      </DialogTitle>
      <DialogContent>
        <CategoryForm
          category={category}
          onSubmit={onSubmit}
          onCancel={onClose}
          isLoading={isLoading}
        />
      </DialogContent>
    </AppDialog>
  );
};

export default CategoryDialog;
